/**
 * nexen point superior access setup
 */

export const superiorSalesList = {
  KongLW: ['KongLW', 'PohKT', 'SawAS', 'EngYH', 'ChanKY'],
  ColinP: ['ColinP', 'KhorTA', 'AngHa', 'LaiCF'],
}

export const superiorArray = ['KongLW', 'ColinP']
